import { render, staticRenderFns } from "./WorkcentreDashboard.vue?vue&type=template&id=2bdc8216&"
import script from "./WorkcentreDashboard.vue?vue&type=script&lang=js&"
export * from "./WorkcentreDashboard.vue?vue&type=script&lang=js&"
import style0 from "./WorkcentreDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports